// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Terminal de pagamento",
    description: "Cobre com o terminal da receção a partir da reserva",
    count: "{count} terminal | {count} terminais",
  },
  settings: {
    title: "Terminais de pagamento da receção",
    lead: "Cobre com o terminal a partir da reserva: o valor aparece no aparelho, o hóspede passa o cartão e a reserva fica paga automaticamente.",
    listTitle: "Os seus terminais",
    add: "Adicionar terminal",
    loading: "A carregar…",
    empty: "Ainda não tem nenhum terminal ligado.",
    simulatorTag: "Simulador",
    online: "Online",
    offlineSince: "Offline · último sinal {when}",
    neverConnected: "Ainda não ligado",
    bridgeVersion: "ponte {version}",
    token: "token",
    newToken: "Novo token",
    remove: "Remover",
    howTitle: "Como ligar",
    how1: "Adicione aqui o terminal e copie o seu token (só é mostrado uma vez).",
    how2: "No computador da receção onde o terminal está ligado, inicie a ponte da WACheckin com esse token.",
    how3: "Quando aqui aparecer «Online», já pode cobrar a partir de qualquer reserva: Adicionar pagamento → Cartão / terminal.",
    bankNote: "Com a Redsys é preciso contratar com o seu banco o «TPV-PC» (modalidade Implantado) e um terminal certificado. Um terminal autónomo por WiFi ou 4G não pode ser ligado.",
    addTitle: "Adicionar terminal",
    nameLabel: "Nome",
    namePlaceholder: "Por exemplo: Receção",
    typeLabel: "Tipo",
    typeReal: "Terminal Redsys (TPV-PC)",
    typeRealHint: "O terminal do seu banco, ligado ao computador da receção.",
    typeSim: "Simulador",
    typeSimHint: "Para testar sem aparelho. Não movimenta dinheiro.",
    cancel: "Cancelar",
    saving: "A guardar…",
    create: "Adicionar",
    saveError: "Não foi possível guardar. Tente novamente.",
    loadError: "Não foi possível carregar os terminais.",
    tokenTitle: "Token do terminal",
    tokenLead: "Introduza estes dois dados na ponte do computador da receção.",
    apiLabel: "Servidor",
    tokenLabel: "Token",
    copy: "Copiar",
    copied: "Copiado",
    tokenOnce: "Guarde-o agora: não volta a ser mostrado. Se o perder, gere um novo e o anterior deixa de valer.",
    done: "Concluído",
    newTokenConfirm: "Gerar um novo token para «{name}»? O atual deixa de valer e terá de ser introduzido de novo na ponte.",
    removeConfirm: "Remover o terminal «{name}»? Deixará de poder receber cobranças.",
    removed: "Terminal removido.",
  },
  add: {
    sendTitle: "Cobrar no terminal",
    sendHint: "O valor aparece no aparelho e a reserva fica paga automaticamente ao passar o cartão.",
    online: "online",
    offline: "offline",
    noneOnline: "Nenhum terminal está online. Verifique se o computador da receção está ligado e a ponte aberta.",
    manualTitle: "Já cobrei, só registar",
    manualHint: "É registado como pago sem passar pelo terminal.",
    submit: "Cobrar no terminal",
  },
  line: {
    pendiente: "A enviar ao terminal",
    enviado: "No terminal",
    sin_respuesta: "Sem resposta · verificar",
  },
  cobro: {
    terminal: "Terminal",
    cancel: "Cancelar cobrança",
    hide: "Continuar em segundo plano",
    notCharged: "Não foi cobrado",
    wasCharged: "Sim, foi cobrado",
    retry: "Tentar de novo",
    close: "Fechar",
    authCode: "Autorização {code}",
    genericError: "Não foi possível concluir. Tente novamente.",
    title: {
      pendiente: "A enviar ao terminal…",
      enviado: "Peça o cartão",
      cobrado: "Cobrado",
      rechazado: "Cartão recusado",
      cancelado: "Cobrança cancelada",
      error: "O terminal deu um erro",
      caducado: "O terminal não respondeu",
      sin_respuesta: "Foi cobrado?",
    },
    text: {
      pendiente: "O valor aparecerá no terminal dentro de segundos.",
      enviado: "O valor já está no terminal. Assim que for pago, a reserva fica marcada automaticamente.",
      cobrado: "Este pagamento já está registado na reserva.",
      rechazado: "Não foi cobrado nada.",
      cancelado: "Não foi cobrado nada.",
      error: "Não foi cobrado nada.",
      caducado: "Não foi cobrado nada.",
      sin_respuesta: "O terminal não devolveu o resultado. Verifique no aparelho ou no talão antes de cobrar de novo.",
    },
  },
  qr: {
    button: "Mostrar QR",
    title: "Digitalize para pagar",
    text: "O hóspede digitaliza-o com o telemóvel e paga na página segura da plataforma de pagamento. A reserva fica paga automaticamente.",
    copy: "Copiar link",
    copied: "Link copiado",
    close: "Fechar",
  },
};
